import { Dialog } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { useState } from "react";
import { toast } from "react-toastify";
import { useAppContext } from "../../context/AppContext";
import CustomDialog from "../basic/Dialog";
import coach_image from "../../assets/images/coach_image.png";
// import IconButton from "../basic/IconButton";
// import ic_close from "../../assets/icons/ic_close.svg";
// import trainer_icon from "../../assets/icons/personal_trainer.png";
import { callMe, reachUs, getCallACoach, postCallACoach } from "../../api/api";
import { useEffect } from "react";
import { validPhone } from "../../utils/Utils";

//Request Submited Dialog
function RequestSubmited({ open, close }) {
  return (
    <CustomDialog show={open} close={close}>
      <Dialog.Panel>
        <div
          className={`lg:w-[1280px] h-full w-auto flex flex-col rounded-xl md:py-20 md:px-36`}
          style={{
            background:
              "linear-gradient(0deg, #222631, #222631),linear-gradient(0deg, #232D38, #232D38)",
          }}
        >
          <div className="flex justify-end md:-mt-24 md:-mr-40">
            <button
              type="button"
              className={`rounded-full p-1 bg-white max-w-max self-end`}
              onClick={close}
            >
              <Icon icon="carbon:close" color={"#000"} className="h-7 w-7" />
            </button>
          </div>
          <div className="md:mx-20 md:mt-24 mx-6 mb-8 md:px-12 px-5 py-6 md:py-12 border border-[#35404D] border-2px rounded-xl">
            <p className="text-4xl text-white font-bold pb-7">
              <span className="text-primary-neonGreen">Request</span> submited
            </p>
            <p className="text-white font-sm font-normal">
              Thank you for submitting a call back request! <br />
              You can expect a call back from your <br />
              Fitness Mentor within next 24 hours.
            </p>
          </div>
          {/* <div className="flex justify-end -mb-28 -mr-44">
            <div className="bg-[#5FEFDE] rounded-full md:w-16 w-auto md:h-16 h-auto flex justify-center items-center">
              <img src={trainer_icon} className="w-12 h-12" />
            </div>
          </div> */}
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

// Request Call-Back
function RequestCall({
  coachId,
  coachName,
  coachImage,
  fieldOfExperty,
  open,
  close,
}) {
  const [requestSubmitedDialog, setRequestSubmitedDialog] = useState(false);
  const [fullName, setFullName] = useState();
  const [mobile, setMobile] = useState();
  const [selectedOption, setSelectedOption] = useState(null);
  const [userQuery, setUserQuery] = useState();

  function handleChange(event) {
    setSelectedOption(event.target.value);
  }

  // Post UseQuery
  async function postUserQuery() {
    let userData = {};
    userData.coach_id = coachId;
    userData.coach_name = coachName;
    userData.firstname = fullName;
    userData.mobile = mobile;
    userData.timeSlot = selectedOption;
    userData.message = userQuery;
    // send the data to the server
    await postCallACoach(userData);
    console.log("Use Query :" + userData);
  }

  return (
    <CustomDialog show={open} close={close}>
      <RequestSubmited
        open={requestSubmitedDialog}
        close={() => {
          setRequestSubmitedDialog(false);
        }}
      />
      <Dialog.Panel>
        <div
          className={`lg:w-[1280px] h-full w-auto flex flex-col rounded-xl py-10 px-12 bg-[#222631] border-[#31DEC9] border-[2px]`}
        >
          <div className="flex justify-end -mt-12 -mr-16">
            <button
              type="button"
              className={`rounded-full p-1 bg-white max-w-max self-end`}
              onClick={close}
            >
              <Icon icon="carbon:close" color={"#000"} className="h-7 w-7" />
            </button>
          </div>
          <p className="text-3xl text-white font-bold text-start">
            <span className="text-primary-neonGreen">Request</span> a call back
          </p>
          <p className="text-start text-white font-sm font-thin pt-1 pb-4">
            Submit your query and get a call back from selected Fitness mentor
          </p>
          <div className="grid lg:grid-cols-5 grid-cols-1 relative py-4">
            <div
              className="group relative flex flex-1 flex-col rounded-2xl shadow-xl -z-0 w-[200px] h-[240px] border-[#31DEC9] border-[1px] md:text-start text-middle"
              style={{
                // backgroundImage: `url(${coach_image})`,
                backgroundImage: `url(${coachImage})`,
                backgroundSize: "cover",
              }}
            >
              <div
                className="text-bottom rounded-2xl -pb-10"
                style={{
                  background:
                    "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 60%)",
                }}
              >
                <p className="text-white font-poppins text-sm font-bold flex justify-end items-center absolute pt-48 px-3">
                  {/* Ram Krishn Balal */}
                  {coachName}
                </p>
                <p className="text-white font-poppins text-sm flex justify-end items-center absolute pt-52 px-3">
                  {/* Agility Export */}
                  {fieldOfExperty}
                </p>
              </div>
            </div>
            <div className="md:col-span-4 w-full h-full text-start border-[#232D38] border-[2px] rounded-md md:px-12 px-2 py-6 text-white">
              <p className="text-white text-lg font-normal font-poppins text-start pb-3">
                Your Name
              </p>
              <div className="flex lg:flex-row flex-col gap-3 pb-4">
                <input
                  placeholder="Full Name"
                  id="full_name"
                  type="text"
                  value={fullName}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setFullName("");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setFullName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                  className="border-[#323A42] border-[2px] rounded-md py-2 mx:px-7 px-10 bg-primary-black"
                  // style={{
                  //   background:
                  //     "background: linear-gradient(0deg, #1D1E22, #1D1E22),linear-gradient(0deg, #323A42, #323A42)",
                  //   opacity: "70",
                  // }}
                />
                <input
                  placeholder="Mobile Number"
                  id="mobile_number"
                  type="number"
                  pattern="[0-9]+"
                  value={mobile}
                  onChange={(e) => {
                    setMobile(e.target.value);
                  }}
                  className="border-[#323A42] border-[2px] rounded-md py-2 mx:px-7 px-6 bg-primary-black"
                />
                <select
                  className="border-[#323A42] border-[2px] rounded-md py-2 mx:px-10 px-10 bg-primary-black"
                  onChange={handleChange}
                >
                  <option disabled selected>
                    Select Slot
                  </option>
                  <option value="10.00-12.00">10.00-12.00</option>
                  <option value="15.00-17.00">15.00-17.00</option>
                  <option value="18.00-20.00">18.00-20.00</option>
                  {/* <option value="03:00">03:00</option> */}
                </select>
              </div>
              <p className="text-white text-lg font-normal font-poppins text-start py-3">
                Your Query
              </p>
              <textarea
                placeholder="Please enter your query here..."
                id="user_query"
                type="text"
                value={userQuery}
                className="border-[#323A42] border-[2px] rounded-md lg:w-[840px] w-full h-auto lg:h-[120px] bg-primary-black py-2 md:px-4 px-4 md:justify-start justify-end"
                style={{ resize: "none" }}
                rows="8"
                autoFocus="none"
                required
                onChange={(e) => {
                  setUserQuery(e.target.value);
                  if (e.target.value == "") {
                    setUserQuery("");
                  } else if (e.target.value.match(/^[A-Za-z0-9]+$/)) {
                    setUserQuery(e.target.value);
                  }
                }}
              />
              <div></div>
            </div>
          </div>
          <div className="flex lg:justify-end justify-center -pt-40 pb-10 md:pr-6">
            <button
              className="bg-[#3E0CA7] text-white text-sm px-12 py-2 rounded-md absolute z-20"
              // onClick={() => {
              //   setRequestSubmitedDialog(true);
              //   console.log("Submited!!");
              // }}
              onClick={async () => {
                if (!fullName) {
                  toast("Name is required", { type: "error" });
                } else if (!validPhone(mobile)) {
                  toast("Invalid mobile", { type: "error" });
                } else if (!validPhone(mobile) && mobile) {
                  toast("Invalid mobile", { type: "error" });
                } else if (selectedOption == null) {
                  toast("Select Slot", { type: "error" });
                } else if (!userQuery) {
                  toast("Please write your query", { type: "error" });
                } else {
                  postUserQuery();
                  // if (postCallACoach.success) {
                  setRequestSubmitedDialog(true);
                  toast("We will respond to you soon");
                  return;
                  // }
                }
              }}
            >
              Submit
            </button>
          </div>
          {/* <div className="flex justify-end -mb-20 -mr-20">
            <div className="bg-[#5FEFDE] rounded-full md:w-16 w-auto md:h-16 h-auto flex justify-center items-center">
              <img src={trainer_icon} className="w-12 h-12" />
            </div>
          </div> */}
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

// Trainer Cards
export function CoachCard({ coachId, coachName, coachImage, fieldOfExperty }) {
  const [showRequestCallDialog, setShowRequestCallDialog] = useState(false);
  return (
    <>
      <RequestCall
        coachId={coachId}
        coachName={coachName}
        coachImage={coachImage}
        fieldOfExperty={fieldOfExperty}
        open={showRequestCallDialog}
        close={() => {
          setShowRequestCallDialog(false);
        }}
      />
      <div className="md:justify-start justify-center md:gap-5 gap-20 pb-10 h-full">
        <div
          className="group relative flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-[200px] min-h-[240px]  max-h-full"
          style={{
            // backgroundImage: `url(${coach_image})`,
            backgroundImage: `url(${coachImage})`,
            backgroundSize: "cover",
          }}
        >
          <div
            className="text-bottom rounded-2xl -pb-10"
            style={{
              background:
                "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 60%)",
            }}
          >
            <p className="text-white font-poppins text-sm font-bold flex justify-end items-center absolute pt-48 px-3">
              {/* Ram Krishn Balal */}
              {coachName}
            </p>
            <p className="text-white font-poppins text-sm flex justify-end items-center absolute pt-52 px-3">
              {/* Agility Export */}
              {fieldOfExperty}
            </p>
            <div className="flex justify-center pt-60">
              <button
                className="bg-[#3E0CA7] text-white text-sm px-12 py-2 rounded-md absolute z-10"
                onClick={() => {
                  setShowRequestCallDialog(true);
                  console.log("Contact 1");
                }}
              >
                Contact
              </button>
            </div>
          </div>
        </div>
        {/* <div
          className="group relative flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-[200px] min-h-[240px]  max-h-full"
          style={{
            backgroundImage: `url(${coach_image})`,
            backgroundSize: "cover",
          }}
        >
          <div
            className="text-bottom rounded-2xl -pb-10"
            style={{
              background:
                "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 60%)",
            }}
          >
            <p className="text-white font-poppins text-sm font-bold flex justify-end items-center absolute pt-48 px-3">
              Ram Krishn Balal
            </p>
            <p className="text-white font-poppins text-sm flex justify-end items-center absolute pt-52 px-3">
              Agility Export
            </p>
            <div className="flex justify-center pt-60">
              <button
                className="bg-[#3E0CA7] text-white text-sm px-12 py-2 rounded-md absolute z-10"
                onClick={() => {
                  setShowRequestCallDialog(true);
                  console.log("Contact 2");
                }}
              >
                Contact
              </button>
            </div>
          </div>
        </div>
        <div
          className="group relative flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-[200px] min-h-[240px]  max-h-full"
          style={{
            backgroundImage: `url(${coach_image})`,
            backgroundSize: "cover",
          }}
        >
          <div
            className="text-bottom rounded-2xl -pb-10"
            style={{
              background:
                "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 60%)",
            }}
          >
            <p className="text-white font-poppins text-sm font-bold flex justify-end items-center absolute pt-48 px-3">
              Ram Krishn Balal
            </p>
            <p className="text-white font-poppins text-sm flex justify-end items-center absolute pt-52 px-3">
              Agility Export
            </p>
            <div className="flex justify-center pt-60">
              <button
                className="bg-[#3E0CA7] text-white text-sm px-12 py-2 rounded-md absolute z-10"
                onClick={() => {
                  setShowRequestCallDialog(true);
                  console.log("Contact 3");
                }}
              >
                Contact
              </button>
            </div>
          </div>
        </div>
        <div
          className="group relative flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-[200px] min-h-[240px]  max-h-full"
          style={{
            backgroundImage: `url(${coach_image})`,
            backgroundSize: "cover",
          }}
        >
          <div
            className="text-bottom rounded-2xl -pb-10"
            style={{
              background:
                "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 60%)",
            }}
          >
            <p className="text-white font-poppins text-sm font-bold flex justify-end items-center absolute pt-48 px-3">
              Ram Krishn Balal
            </p>
            <p className="text-white font-poppins text-sm flex justify-end items-center absolute pt-52 px-3">
              Agility Export
            </p>
            <div className="flex justify-center pt-60">
              <button
                className="bg-[#3E0CA7] text-white text-sm px-12 py-2 rounded-md absolute z-10"
                onClick={() => {
                  setShowRequestCallDialog(true);
                  console.log("Contact 4");
                }}
              >
                Contact
              </button>
            </div>
          </div>
        </div> */}
        <div className="md:block hidden group flex-col rounded-2xl w-[360px] min-h-[240px] max-h-full"></div>
      </div>
    </>
  );
}

function CallCoachDialog({ open, close }) {
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [detailsOfCoach, setDetailsOfCoach] = useState();

  // Coach Details getAPI
  const coachDetails = async () => {
    const res = await getCallACoach();
    console.log(res);
    const details = [];
    if (res.success) {
      res["coaches"].forEach((element) => {
        details.push({
          coachId: element.coachId,
          coachName: element.coachName,
          coachImage: element.img,
          fieldOfExperty: element.expert,
        });
      });
      setDetailsOfCoach(details);
      console.log("Coach Details : " + details);
    }
  };

  useEffect(() => {
    // coachDetails();
  }, []);

  //   const sendCallMe = async () => {
  //     if (mobile.length != 10) {
  //       toast("Enter a valid mobile number", { type: "error" });
  //     } else {
  //       const response = await callMe(mobile, "call");
  //       if (response.success) {
  //         toast("We will respond to you soon");
  //         setMobile("");
  //         close();
  //       }
  //     }
  //   };

  //   const sendReachUs = async () => {
  //     if (!validateEmail(email)) {
  //       toast("Enter a valid Email", { type: "error" });
  //     } else {
  //       const response = await reachUs(email, "Get a call CTA");
  //       if (response.success) {
  //         toast("We will respond to you soon");
  //         setEmail("");
  //         close();
  //       }
  //     }
  //   };

  const appState = useAppContext();
  return (
    <CustomDialog show={open} close={close}>
      <Dialog.Panel>
        <div
          className={`lg:w-[1280px] w-full h-full flex flex-col md:justify-start justify-center rounded-xl py-10 px-12`}
          style={{
            background: "linear-gradient(90deg, #2D1735 0%, #23172A 100%)",
          }}
        >
          <div className="flex justify-end -mt-12 -mr-16">
            <button
              type="button"
              className={`rounded-full p-1 bg-white max-w-max self-end`}
              onClick={close}
            >
              <Icon icon="carbon:close" color={"#000"} className="h-7 w-7" />
            </button>
          </div>

          <p className="text-3xl font-bold font-poppins text-white md:text-start text-middle">
            Connect with{" "}
            <span className="text-primary-neonGreen">Fitness Experts</span>
          </p>
          <p className="text-sm font-normal pt-2 pb-4 text-white md:text-start text-middle">
            Schedule a session with below fitness experts
          </p>

          <div className="my-6 gap-5 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 md:-mb-20">
            {detailsOfCoach?.map((list, index) => {
              return (
                // <div className="md:justify-start justify-center md:gap-5 gap-20 md:pb-40 pb-10">
                <CoachCard {...list} key={index} />
                // </div>
              );
            })}
          </div>

          {/* <CoachCard /> */}
          {/* <div className="flex justify-end -mb-20 -mr-20">
            <div className="bg-[#5FEFDE] rounded-full md:w-16 w-auto md:h-16 h-auto flex justify-center items-center">
              <img src={trainer_icon} className="w-12 h-12" />
            </div>
          </div> */}
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default CallCoachDialog;
